module.exports = __webpack_public_path__ + "static/media/gender_based_violence_grey.d5aba47b.svg";